import axiosService from '@Lib/axiosService';

const url = `${process.env.URL}/notifications`;

export const getNotifications = (params) => {
  return axiosService.get(url, params).then((res) => res.data);
};

export const getUnreadNotificationCount = () => {
  return axiosService.get(`${url}/unread-count`).then((res) => res.data.data.unread_count || 0);
};

export const markNotificationAsRead = (id) => {
  return axiosService.post(`${url}/${id}/mark-as-read`).then((res) => res.data.data);
};

export const markAllNotificationsAsRead = () => {
  return axiosService.post(`${url}/mark-all-as-read`).then((res) => res.data.data);
};
